import {EmploymentType} from "../types/ResumeTypes";
import {RecruitmentFilterCodeType, RecruitmentFilterType} from "../types/RecruitmentTypes";
import {CountriesData} from "../constants/IvyConstants";

export const ConstantUtils = {
    convertToEmployment: (employmentType: EmploymentType) => {
        switch (employmentType) {
          case 'PERMANENT_EMPLOYEE':
              return '정규직';
          case 'PART_TIME':
              return '파트 타임';
          case 'CONTRACT_WORKER':
              return "계약직";
          case 'INTERN':
              return "인턴";
          case 'FREELANCER':
              return "프리랜서";
          case 'ETC':
              return "기타";
          default:
              return "";
        }
    },

    convertToEducation: (educationLevel: string) => {
        switch (educationLevel) {
            case 'EDU_0':
                return '고등학교';
            case 'EDU_1':
                return '검정고시';
            case 'EDU_2':
                return "사이버대학";
            case 'EDU_3':
                return "대학교(2~3년제)";
            case 'EDU_4':
                return "대학교(4년제이상)";
            case 'EDU_5':
                return "대학원(석사)";
            case 'EDU_6':
                return "대학교(박사)";
            default:
                return "";
        }
    },

    convertToRecruitmentFilter: (code: string): RecruitmentFilterType | null => {
        if(['대기업', '중견기업', '중소기업', '소기업'].indexOf(code) >= 0){
            return {id: code, type: 'COMPANY_SCALE'};
        }else if(['1', '2', '85'].indexOf(code) >= 0){
            return {id: code, type: 'REGION'};
        }
        return null;
    },

    countryCodeToName: (code: string): string => {
        const country = CountriesData.find(country => country.code === code);
        return country ? country.name : '';
    },

    convertToMilitaryStatus: (code: string): string => {
        switch (code) {
            case "Completed":
                return "필";
            case "NotCompleted":
                return "복무중";
            case "Exempt":
                return "면제";
            case "None":
                return "미필";
            default:
                return "";
        }
    }


}